<span [innerHTML]="question.information | content: question.id"></span>
